module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_5010.c58ad551.png";